// extracted by mini-css-extract-plugin
export default {"cls1":"WinBackPing-cls1_CQV","cls2":"WinBackPing-cls2__vK WinBackPing-cls1_CQV"};